import { SET_SUBMIT_SELECTED_OPTION } from "../actions/submitPageComponentAction";
const initialState = {
  selectedOption: null, 
};

const selectedSubmitOptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SUBMIT_SELECTED_OPTION:{
        const { option } = action.payload;
        return {    
            ...state,
            selectedOption: option, 
        };
    }
    default:
      return state;
  }
};

export default selectedSubmitOptionReducer;
